module.exports = __webpack_public_path__ + "img/photouploadblue-small.0d19e11e.png";